module.exports = __webpack_public_path__ + "img/product_78.ed0729c.webp";